<template>
  <div>
    <!--<Navbar />-->
    <div class="content-i">
      <div class="content-box" style="padding-bottom: 0px;">
        <div class="element-wrapper" style="padding-bottom: 0px;">
          <h6 class="element-header">{{ t('titlePaymentSummary','titlePaymentSummary') }}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
				<template v-if='is_finished'>
					<div class="container">
						<div class="element-info-text mb-3">
							<template v-if='payment_id'>
								<h5 class="element-inner-header">Receipt</h5>
								<div class="element-inner-desc">Details as follows for Order ID {{order_id}} (Batch ID {{batch_id}})</div>
							</template>
							<template v-else>
								<h5 class="element-inner-header">Payment History</h5>
								<div class="element-inner-desc">These are all the payments made against this document</div>
							</template>
						</div>							
						<div class="table-responsive">
							<table class="table table-striped table-hover">
								<thead class="brand-color">
									<tr >
										<th class="text-left">Document Reference</th>
										<th class="text-left">Customer Reference</th>
										<th class="text-left">Order No</th>
										<th class="text-left">Payment Status</th>
										<th class="text-left">Payment Date</th>
										<th class="text-left">Payment Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="detail in details">							
										<td class="text-left"><a target="_blank" :href="view + detail.document_id">{{detail.document_reference}}</a></td>
										<td class="text-left">{{detail.customer_reference}}</td>
										<td class="text-left">{{detail.order_id}}</td>
										<td class="text-left">{{detail.status}}</td>
										<td class="text-left">{{detail.transaction_datetime}}</td>
										<td class="text-left">£{{detail.amount_paid}}</td>
									</tr>					
								</tbody>
								<tfoot>
									<tr>
										<td colspan="4"></td>
										<td><b>Total Paid</b></td>
										<td>£{{amount_paid}}</td>
									</tr>
								</tfoot>
							</table>
						</div>
						<a href="javascript:;" onclick="window.print();">Print payment receipt</a>
						<!--<p><a v-bind:href="finished">Go to documents page</a></p>-->
					</div>
				</template>
				<template v-else>
					<p>There is no payment summary</p>
				</template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { mapActions, mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import Loading from 'vue-loading-overlay'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalEmailInfo from '@/components/DeliveryReports/ModelEmailInfo.vue'
import Calculations from '@/components/Calculations.vue'
import { VclTable } from 'vue-content-loading'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

// NS-9511 DL - new functionality for online payments	
export default {
	name: 'PaymentSummary',
	props: ['id'],
	data() {
		return {
			view: window.location.origin + '/document/view/online/',
			payment_id: null,
		}
	},
	computed: {
		documents() {
			return [this.id]
		},
		transaction() {
			return this.$store.getters['onlinePaymentStore/getTransaction'] || []
		},
		has_documents: function(){
			return this.documents.length > 0 || false;
		},
		details: function(){
			return this.transaction.details || [];
		},	
		is_finished: function(){
			return this.details.length > 0 || false;
		},
		client: function(){
			return this.transaction.short_name || '';
		},
		batch_id: function(){
			return this.transaction.batch_id || '';
		},	
		order_id: function(){
			return this.transaction.order_id || '';
		},			
		name: function(){
			return this.transaction.name || '';
		},
		total_value: function(){
			return this.transaction.total_value || 0;
		},
		amount_paid: function(){
			return this.transaction.amount_paid || 0;
		}		
	},	
	methods: {
	   getTransaction() {
			console.log('getTransaction > documents', this.documents)
			if(this.has_documents) {
				this.$store.dispatch('onlinePaymentStore/getTransaction',{documents: this.documents})
			}
		},
	},
	created() {
		this.getTransaction();
	},
/*	
  components: {
    Navbar,
    Loading,
    ResponseInfo,
    datePicker,
    ModalEmailInfo,
    Calculations,
    VclTable
  }
  */
}
</script>

<style scoped>
  .text-netsend-blue {
    color: #047bf8;
  }
  .showhand {
    cursor: pointer;
  }
  .reports-search-border {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 10px;
  }
  #reportsToggle {
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
  }
  #reportsToggle.collapsed {
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(180deg);
    transform:rotate(180deg);
  }
  .reports-search div:first-child.input-group {
    margin-left: 10px;
  }
  fieldset >>> legend::before {
    background-color: transparent;
  }
  fieldset >>> legend {
    color: #3E4B5B;
  }
  .busy-row {
    display: contents;
  }
  .spinner-row {
    min-height: 150px;
  }
  .table-records-info {
    display: flex;
    align-items: center;
  }
  table >>> tbody, table >>> thead {
    text-align: center;
  }
  .summary-div {
    padding: 10px 20px 10px 20px;
  }
  .summary-values {
    border: 1px solid rgba(0, 0, 0, 0.3);
    padding: 5px;
  }
  .summary-values > strong {
    padding: 0px;
  }
  .table-responsive >>> .white-space {
    white-space: pre;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table-records-info > p {
    margin-bottom: 0px;
  }
  .send-line {
    border: 0px;
    margin: 5px 0px 5px 0px;
    height: 1px;
    background-color: rgba(83, 101, 140, 0.33);
  }
</style>
